import { render, staticRenderFns } from "./IFrameModal.vue?vue&type=template&id=7d77e4eb"
import script from "./IFrameModal.vue?vue&type=script&lang=ts"
export * from "./IFrameModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports